import React, { useState } from "react";
import { RCCAlert, RCCButton, RCCChartPieChart, RCCGrid, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { AuditType } from "src/pages/Audits/Panel/interface";
import objectToPieChartData from "src/utils/objectToPieChartData";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { colorChart, IDashboardAuditsDataPieChart } from "../interface";
import { FilterButton, FilterButtonSelected } from "../styles";

const DashboardPieChartAudits: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const [dataProjects, setDataProjects] = useState<IDashboardAuditsDataPieChart[] | undefined>(undefined);

	const [filterList, setFilterList] = useState<AuditType | undefined>();
	const [totalItenGrouped, setTotalItenGrouped] = useState<{ external: number, internal: number }>({
		external: 0,
		internal: 0
	});


	const translateNameProjects = (name: string) => {
		switch(name){
		case "opened":
			return translate("Abertas");
		case "inAudit":
			return translate("Em Auditoria");
		case "finished":
			return translate("Concluídas");
		default:
			return "";
		}
	};

	const {loading} = useEffectFetchData<any> (
		"DashboardAudits/AuditsForPieChart", {
			type: filterList ?? ""
		},
		({ data }) => {
			const array = objectToPieChartData(data);
			const translateArray = array.filter((x) => x.name !== "count" && x.name !== "internal" && x.name !== "external").map((x) => ({
				...x,
				name: translateNameProjects(x.name)
			}));

			if(!filterList && data){
				setTotalItenGrouped({
					external: data.external,
					internal: data.internal
				});
			}

			setDataProjects(translateArray);
		},[filterList]
	);

	const filterAuditsOnClickBar = (quadrant: AuditType) => {
		let quadrantToUpdate: AuditType | undefined = quadrant;	
		if(filterList && filterList === quadrant)
			quadrantToUpdate = undefined;
		setFilterList(quadrantToUpdate);
	};

	
	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Gráfico Auditorias por Situação")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<RCCGrid container justifyContent="flex-end">
					<RCCTooltip
						text={`${totalItenGrouped.internal}	${totalItenGrouped.internal > 1 ? translate("Internas") : translate("Interna")}`}
						color="green"
					>
						<RCCButton 
							color="green" 
							styleInline={filterList && filterList !== AuditType.INTERNAL ? FilterButtonSelected : FilterButton}
							onClick={(e) => { e.stopPropagation(); filterAuditsOnClickBar(AuditType.INTERNAL); }}
						>
					 	{totalItenGrouped.internal}	{totalItenGrouped.internal > 1 ? translate("Internas") : translate("Interna")}
						</RCCButton>
					</RCCTooltip>
					<RCCTooltip
						text={`${totalItenGrouped.external}	${totalItenGrouped.external > 1 ? translate("Externas") : translate("Externa")}`}
						color="red"
					>
						<RCCButton 
							color="red" 
							styleInline={filterList && filterList !== AuditType.EXTERNAL ? FilterButtonSelected : FilterButton}
							onClick={(e) => { e.stopPropagation(); filterAuditsOnClickBar(AuditType.EXTERNAL); }}
						>
					 	{totalItenGrouped.external}	{totalItenGrouped.external > 1 ? translate("Externas") : translate("Externa")}
						</RCCButton>
					</RCCTooltip>
				</RCCGrid>
				<Link to={`/audit/panel/?type=${filterList ?? ""}`}>
					<RCCTooltip
						text={translate("Painel de Auditorias")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="audits"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>

			<RCCGrid container justifyContent="center" style={{height: "250px", position: "relative"}}>
				{dataProjects && dataProjects.length > 0 ? (
					<>
						<RCCChartPieChart
							width={500}
							height={400}
							pie={[{
								data: dataProjects,
								isAnimationActive: true,
								label: true,
								showTotal: true
							}]}
							colorsPallete={colorChart}
						/>
					</>
				): (
					<RCCAlert 
						title={translate("Atenção")}
						description={translate("Não foram encontrados dados")}
					/>
				)}
			</RCCGrid>
		</DefaultContainer>
	);
};

export default DashboardPieChartAudits;
